export default {
  methods: {
    hasYtdValue: function(kpi) {
      if (!kpi || !kpi.YTD) return false;
      return (
        _.find(kpi.YTD, function(o) {
          return o.Year === 2020 || o.Year === 2021;
        }) !== undefined
      );
    },
    getYtdValue: function(kpi) {
      if (!kpi || !kpi.YTD) return undefined;

      let result = 0;
      for (const ytd of kpi.YTD) {
        if (ytd.Result || ytd.Result === 0) {
          result += ytd.Result
        }
      }
      return result / kpi.YTD.length;
    }
  }
};
